/* eslint-disable default-case */
import React, { Fragment, useReducer, useEffect, useCallback } from "react";
import { useAuth0, user } from "@auth0/auth0-react";
import ai from "../../helpers/axios";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Quote2025Preview from "./quote-2025-preview";
import Dropzone from "../shared/dropzone";
import { LoadingButton } from "../shared/loading-button";
import PageHeader from "../shared/page-header";
import getApiErrorMessage from "../../helpers/get-api-error-message";

console.log("outside of function?");

const reducer = (state, action) => {
  switch (action.type) {
    case "dataBeganDownloading": {
      return {
        ...state,
        loading: true,
      };
    }
    case "fieldChanged": {
      return {
        ...state,
        [action.field]: action.value,
      };
    }
    case "dataDownloaded": {
      return {
        ...state,
        quote: action.payload.data,
        emailPreview: action.payload.emailPreview,
      };
    }
    case "landingPagePreviewDownloaded": {
      return {
        ...state,
        landingPagePreview: action.payload,
      };
    }
    default:
      break;
  }

  return state;
};

const SingleQuote = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { user } = useAuth0();

  const initialState = {
    loading: true,
    emailPreview: {
      template: "",
    },
    quote: {
      cc: [],
      bcc: [],
      email: [],
      bccSender: true,
      leadData: {
        assigneeName: "",
        assigneeId: "",
      },
      quoteTag: "",
    },
    testEmailInputValue: "",
    testEmails: [],
    attachments: [],
    teamMembers: [],
    sendAs: {
      label: `${user.name} <${user.email}>`,
      value: user.email,
      id: user.sub,
    },
    sendAsDefault: {
      label: "",
      value: "",
      id: "",
    },
    landingPagePreview: {
      html: "",
      subject: "",
    },
    isSend2025QuoteLoading: false,
  };

  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const [state, dispatch] = useReducer(reducer, initialState);

  const getData = async () => {
    dispatch({ type: "dataBeganDownloading" });

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });
    let emailPreview;

    let response = await ai
      .auth(token)
      .get(`/api/quotes/${id}`)
      .catch((error) => {
        history.push({ pathname: "/quotes" });

        setTimeout(() => {
          toast.error("Unauthorized!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }, 50);

        return console.error(error.response);
      });

    if (response && response.data) {
      emailPreview = await ai
        .auth(token)
        .get(`/api/quotes/${id}/emailPreview?sendAs=${state.sendAs.id}`)
        .catch((error) => {
          console.error(error);
          return;
        });

      await getTeamMembers(response.data);

      if (emailPreview) {
        emailPreview = emailPreview.data;

        dispatch({
          type: "dataDownloaded",
          payload: {
            data: response.data,
            emailPreview: emailPreview,
          },
        });
      }

      console.log("get data running");
    }
  };

  useEffect(() => {
    getData();
    // getTeamMembers();
    document.title = "Preview Quote | evoJets HQ";
    getLandingPagePreview();
  }, []);

  useEffect(() => {
    getEmailPreview();
  }, [state.sendAs.id]);

  const getLandingPagePreview = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    try {
      const { data } = await ai
        .auth(token)
        .get(`/api/quotes/${id}/landingPagePreview?sendAs=${state.sendAs.id}`);

      dispatch({
        type: "landingPagePreviewDownloaded",
        payload: data,
      });

      console.log("Landing page preview loaded");
    } catch (error) {
      console.error("Error loading landing page preview:", error);
      toast.error("Failed to load 2025 quote preview", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const send2025Quote = async (event) => {
    event.preventDefault();

    if (state.isSend2025QuoteLoading) {
      return;
    }

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    dispatch({
      type: "fieldChanged",
      field: "isSend2025QuoteLoading",
      value: true,
    });

    try {
      // Create FormData to send attachments
      let formData = new FormData();

      // Add attachments from Dropzone
      for (const file of state.attachments) {
        formData.append("attachments[]", file);
      }

      // Add sendAs data
      formData.append("sendAs", JSON.stringify(state.sendAs));

      // Send with FormData instead of JSON
      const response = await ai.auth(token)({
        method: "post",
        url: `/api/quotes/${id}/send2025Quote`,
        data: formData,
      });

      if (response.data.success) {
        toast.success("2025 Quote sent successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        document
          .getElementById("nav-container")
          .scrollIntoView({ behavior: "smooth" });

        console.log("2025 quote response:", response.data);

        // Sync to app after successful send
        try {
          const syncResponse = await ai
            .auth(token)
            .post(`/api/quotes/${id}/syncToAppOffer`);

          if (syncResponse.data.success) {
            toast.success("Quote synced to app successfully!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });

            // Refresh data to show updated information
            getData();
          }
        } catch (syncError) {
          console.error("Error syncing to app:", syncError);

          toast.error(
            syncError.response?.data?.message || "Failed to sync quote to app",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      }
    } catch (error) {
      console.error("Error sending 2025 quote:", error);

      toast.error(
        error.response?.data?.message || "Failed to send 2025 quote",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      // Always set loading back to false
      dispatch({
        type: "fieldChanged",
        field: "isSend2025QuoteLoading",
        value: false,
      });
    }
  };

  const getEmailPreview = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let { data } = await ai.auth(token).get(`/api/quotes/${id}`);
    let { data: emailPreview } = await ai
      .auth(token)
      .get(`/api/quotes/${id}/emailPreview?sendAs=${state.sendAs.id}`);

    console.log(data);

    dispatch({
      type: "fieldChanged",
      field: "emailPreview",
      value: emailPreview,
    });

    console.log("get emailPreviewRunning running");
  };

  const getTeamMembers = async (quoteData) => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let { data } = await ai.auth(token).get(`/api/users/getTeamMembers`);

    dispatch({
      type: "fieldChanged",
      field: "teamMembers",
      value: data,
    });

    console.log("TEAM", data);

    if (
      user["https://new.evojets.com/roles"].includes("Sales Assistant") ||
      user["https://new.evojets.com/roles"].includes("Dynamic Sales Assistant")
    ) {
      console.log("STATE", quoteData.leadData.assigneeId);

      //for DSA, remove the other users as options to send from

      let assignee = data.filter(
        (item) => item.user_id === quoteData.leadData.assigneeId
      );

      if (assignee.length) {
        if (assignee?.user_id !== user.sub) {
          dispatch({
            type: "fieldChanged",
            field: "teamMembers",
            value: assignee,
          });
        }

        dispatch({
          type: "fieldChanged",
          field: "sendAs",
          value: {
            label: `${assignee[0].name} <${assignee[0].email}>`,
            value: assignee[0].email,
            id: assignee[0].user_id,
          },
        });

        // console.log("ASSIGNEE", assignee.user_id,)
      }
    }
  };

  const emailComponents = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleTestEmailChange = (newValue, arg2, arg3, arg4) => {
    dispatch({
      type: "fieldChanged",
      field: "testEmails",
      value: newValue || [],
    });
  };

  const handleTestEmailInputChange = (inputValue, action) => {
    dispatch({
      type: "fieldChanged",
      field: "testEmailInputValue",
      value: inputValue,
    });

    if (
      action.action === "menu-close" &&
      validateEmail(state.testEmailInputValue)
    ) {
      dispatch({
        type: "fieldChanged",
        field: "testEmails",
        value: [...state.testEmails, createOption(state.testEmailInputValue)],
      });

      dispatch({
        type: "fieldChanged",
        field: "testEmailInputValue",
        value: "",
      });
    }

    console.log("Input Change", inputValue);
    console.log("Test Email Change arg2", action);
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleTestEmailKeyDown = (event) => {
    const { testEmailInputValue, testEmails } = state;
    if (!testEmailInputValue || !validateEmail(testEmailInputValue)) return;

    switch (event.key) {
      case "Enter":
      case "Tab":
        dispatch({
          type: "fieldChanged",
          field: "testEmails",
          value: [...testEmails, createOption(testEmailInputValue)],
        });

        dispatch({
          type: "fieldChanged",
          field: "testEmailInputValue",
          value: "",
        });

        event.preventDefault();
    }
  };

  const returnToEditor = (event) => {
    event.preventDefault();
    history.push({
      pathname: `/quotes/${state.quote._id}/edit`,
    });
  };

  const sendTestEmail = async (event) => {
    event.preventDefault();
    console.log(state.testEmails);

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let formData = new FormData();
    let recipients = state.testEmails.map((item) => item.value);

    formData.append("recipients", JSON.stringify(recipients));

    for (const file of state.attachments) {
      formData.append("attachments[]", file);
    }

    formData.append("sendAs", JSON.stringify(state.sendAs));

    let response = await ai
      .auth(token)({
        method: "post",
        url: `/api/quotes/${id}/sendTestEmail`,
        data: formData,
      })
      .catch((error) => {
        console.error(error.response.data);

        toast.error(getApiErrorMessage(error, "Request failed."), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;

        // return history.push({ path: "/quotes" });
      });

    if (response) {
      toast.success("Test Email Sent!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      document
        .getElementById("nav-container")
        .scrollIntoView({ behavior: "smooth" });

      console.log(response.data);
    }
  };

  const getSenderOptions = () => {
    let senderOptions = [
      {
        label: `${user.name} <${user.email}>`,
        value: user.email,
        id: user.sub,
      },
    ];

    if (state.teamMembers.length) {
      state.teamMembers.map((member) => {
        let formattedMember = {
          label: `${member.name} <${member.email}>`,
          value: member.email,
          id: member.user_id,
        };
        senderOptions.push(formattedMember);
      });
    }

    return senderOptions;
  };

  const bccList = () => {
    let bcc = false;
    if (state.quote?.bccSender) {
      bcc = `${state.sendAs.label}`;
    }
    if (state.quote?.bcc?.length) {
      bcc += ", " + state?.quote?.bcc?.join(", ");
    }

    console.log("BCC", state.quote?.bcc);
    return bcc;
  };

  const syncToAppOffer = async (event) => {
    event.preventDefault();

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    try {
      const response = await ai
        .auth(token)
        .post(`/api/quotes/${id}/syncToAppOffer`);

      if (response.data.success) {
        toast.success("Quote synchronized to app successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Refresh data to show updated information
        getData();
      }
    } catch (error) {
      console.error("Error syncing to app:", error);

      toast.error(
        error.response?.data?.message || "Failed to sync quote to app",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const isAppOfferOutOfSync = () => {
    // If there's no appOffer, it's definitely out of sync
    if (!state.quote.appOffer || !state.quote.appOffer.syncedAt) return true;

    // Check if the quote has been modified since the last sync
    // Add a 5-second buffer to account for small timing differences
    const syncedAt = new Date(state.quote.appOffer.syncedAt).getTime();
    const updatedAt = new Date(state.quote.updatedAt).getTime();

    // Consider it in sync if the quote was updated within 5 seconds of the sync
    const bufferMs = 5000; // 5 seconds in milliseconds

    return updatedAt - syncedAt > bufferMs;
  };

  const viewPDFPreview = async (event) => {
    event.preventDefault();

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    try {
      const response = await ai
        .auth(token)
        .get(`/api/quotes/${id}/landingPagePDF?sendAs=${state.sendAs.id}`, {
          responseType: "blob",
        });

      // Create blob and blob URL
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create timestamp for filename (same format as backend)
      const now = new Date();
      const estTime = new Date(
        now.toLocaleString("en-US", { timeZone: "America/New_York" })
      );
      const month = estTime.getMonth() + 1;
      const day = estTime.getDate();
      const year = estTime.getFullYear().toString().slice(-2);
      const hour = estTime.getHours();
      const minute = estTime.getMinutes().toString().padStart(2, "0");
      const ampm = hour >= 12 ? "PM" : "AM";
      const hour12 = hour % 12 || 12;

      const timestamp = `${month}.${day}.${year} ${hour12}:${minute}${ampm} EST`;
      const filename = `evoJets Charter Quote (${timestamp}).pdf`;

      // Create download link and trigger download
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Open in new tab for viewing
      window.open(url, "_blank");

      // Clean up the blob URL after a short delay
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    } catch (error) {
      console.error("Error viewing PDF preview:", error);
      toast.error("Failed to generate PDF preview", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <Fragment>
      <PageHeader
        pageTitle="Preview Quote"
        breadcrumbs={[
          {link: '/quotes', label: 'Quotes'},
          {
            label: `Preview Quote #${state.quote.quoteTag}`,
            isCurrentPage: true,
          },
        ]}
        goBackLink="/quotes"
      />

      <div className="pdf-preview-section mb-20 text-center">
        <button
          onClick={viewPDFPreview}
          className="btn-pdf-preview base-button evo-blue mt-10"
          type="button"
        >
          View PDF Preview
        </button>
      </div>

      {/* NEW: 2025 Quote PDF Preview Section */}
      <Quote2025Preview
        landingPagePreview={state.landingPagePreview}
      ></Quote2025Preview>

      {/* MOVED: Email Headers Section - moved to top */}
      <div id="emailHeaders">
        <h3>Email Headers</h3>
        <p>
          <strong>To: </strong>
          {state.quote &&
            `${state.quote.firstName} ${
              state.quote.lastName
            } <${state.quote.email.join(", ")}>`}
        </p>

        {state.quote.cc && state.quote.cc.length ? (
          <p>
            <strong>Cc: </strong>
            {state.quote.cc.join(", ")}
          </p>
        ) : (
          ""
        )}

        {bccList() && (
          <p>
            <strong>Bcc: </strong>
            {bccList()}
          </p>
        )}

        <p>
          <strong>Subject: </strong>
          {state.landingPagePreview.subject || state.emailPreview.subject}
        </p>
      </div>

      {/* MOVED: Sender Selection - moved to top */}
      <div className="form-group mt20">
        <label htmlFor="sendAs-select">
          <strong>Select a Sender</strong>
        </label>

        <Select
          key={`sendAs-${state.teamMembers.length}`}
          className="sendAs-select"
          classNamePrefix="select"
          name="sendAs-select"
          value={state.sendAs}
          options={getSenderOptions()}
          placeholder="Select a Sender"
          onChange={(sender) => {
            dispatch({
              type: "fieldChanged",
              field: "sendAs",
              value: sender,
            });
          }}
          defaultValue={{
            label: state.sendAsDefault.label,
            value: state.sendAsDefault.value,
            id: state.sendAsDefault.id,
          }}
        ></Select>
      </div>

      {/* NEW: Send 2025 Quote Button */}
      <form id="send2025Quote" onSubmit={send2025Quote}>
        <LoadingButton
          className="btn-2025-quote mb-20 evo-blue base-button w-100"
          type="submit"
          isLoading={state.isSend2025QuoteLoading}
        >
          Send 2025 Quote Email w/ PDF
        </LoadingButton>
      </form>

      <form id="syncToAppForm" onSubmit={syncToAppOffer} className="mb-20">
        <input
          type="submit"
          value={`Save & Sync To App${
            isAppOfferOutOfSync() ? " (Out of Sync)" : ""
          }`}
          className={`sync-app-btn ${
            isAppOfferOutOfSync() ? "out-of-sync" : ""
          }`}
        />
      </form>

      <Dropzone dispatch={dispatch} attachments={state.attachments}></Dropzone>

      {/* EXISTING: Test Email Form */}
      <form id="sendTestEmail" onSubmit={sendTestEmail}>
        <div className="form-group mt20">
          <label htmlFor="email">
            <strong>Send Test Email</strong>
          </label>
          <CreatableSelect
            className="email-select"
            classNamePrefix="select"
            placeholder="Enter Email Addresses"
            components={emailComponents}
            isClearable
            isMulti
            menuIsOpen={false}
            onChange={handleTestEmailChange}
            onInputChange={handleTestEmailInputChange}
            onKeyDown={handleTestEmailKeyDown}
            inputValue={state.testEmailInputValue}
            value={state.testEmails}
            name={"testEmails"}
            inputId={"testEmails"}
          ></CreatableSelect>
        </div>

        <input type="submit" value="Send Test Email" className="mb-20"></input>
      </form>

      {/* EXISTING: Return to Editor Button */}
      <button id="returnToEditor" onClick={returnToEditor}>
        Return to Editor
      </button>
    </Fragment>
  );
};

export default SingleQuote;
